import React from "react";
import { observer } from "mobx-react";
import ReactQuill from "react-quill";
import { debounce } from "debounce";
// eslint-disable-next-line
import EditorToolbar, { modules, formats } from "./EditorToolbar";

import { Container, ToolbarWrapper } from "./styles";
import "./css";

type Props = {
  config?: string;
  placeholder?: string;
  content: string;
  stickyToolbar?: boolean;
  onChange: (content: string) => void;
  readOnly?: boolean;
  changeDebounce?: number;
  editorRef?: any;
};

const EDITOR_SCROLL_CONTAINER_ID = "editorScrollContainer";

@observer
class Editor extends React.Component<Props> {
  onChange = debounce(this.props.onChange, this.props.changeDebounce ?? 500);

  render() {
    const {
      config,
      stickyToolbar,
      content,
      placeholder,
      readOnly,
      editorRef,
    } = this.props;

    return (
      <Container stickyToolbar={stickyToolbar}>
        <ToolbarWrapper readOnly={readOnly}>
          <EditorToolbar config={config} />
        </ToolbarWrapper>
        <ReactQuill
          placeholder={
            readOnly ? "The text is no longer editable" : placeholder
          }
          theme="snow"
          value={content}
          onChange={this.onChange}
          modules={modules}
          formats={formats}
          id="react-quill"
          bounds="#react-quill"
          scrollingContainer={
            document.getElementById(EDITOR_SCROLL_CONTAINER_ID) || undefined
          }
          readOnly={readOnly}
          ref={editorRef}
        />
      </Container>
    );
  }
}

export default Editor;
